import { render, staticRenderFns } from "./ListCISComplaints.vue?vue&type=template&id=f99d16e2&scoped=true&"
import script from "./ListCISComplaints.vue?vue&type=script&lang=js&"
export * from "./ListCISComplaints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99d16e2",
  null
  
)

export default component.exports